import { httpClient } from '@/lib/api-client'
import {
  localProfileProxyPrefix,
  profileApiPath,
  profileApiUrl,
} from '@/config/profile-api'
import {
  parseSessionProfile,
  type SessionProfile,
} from '../model/session-profile'

// Dev only: route through the Vite proxy (vite.config.ts) so the ProbeStack
// session cookie is injected server-side, bypassing cross-site cookie
// restrictions between localhost:5173 and probestack.io.
export const profileEndpoint = import.meta.env.DEV
  ? `${localProfileProxyPrefix}${profileApiPath}`
  : profileApiUrl

export async function getSessionProfile(): Promise<SessionProfile> {
  const response = await httpClient.get<unknown>(profileEndpoint)
  return parseSessionProfile(response.data)
}
